import { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { DataEntitiesOperator, OperatorApi } from '../../shared/api/axios-client';
import { createApiService } from '../../shared/apiConfig';
import { AdminRevenueReport } from '../../Reports/AdminRevenueReport';
import { PageBar } from '../../Controls/PageBar';

const operatorApi = createApiService(OperatorApi);

export function AdminRevenueReportPage() {
    const [operators, setOperators] = useState<DataEntitiesOperator[]>([]);

    useEffect(() => {
        (async () => {
            const response = await operatorApi.list({});
            if (response.data?.items) {
                setOperators(response.data.items);
            }
        })();
    }, []);

    return (
        <Container fluid className="h-100">
            <PageBar title="Revenue Report" />
            <AdminRevenueReport
                operators={operators.map((o) => ({
                    operatorId: o.operatorId!,
                    name: o.name,
                }))}
                heightOffset={80}
            />
        </Container>
    );
}
